import { RouterManager } from '@aclass/admin/managers';
import { QuoteStory } from '@aclass/admin/storage/actions';
import { IAdminState, IQuoteModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class QuoteSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:quote-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IQuoteModuleState['searchPageInitialized']>(['quoteModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(QuoteSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(QuoteStory.dryRunSearchPage());
    }
}
